/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { WearablesStrictHttpResponse } from '../../wearables-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProcessResponseModel } from '../../models/process-response-model';

export interface SdkProcessPlatformVersionDataTypePost$Params {

/**
 * Target platform identifier.
 */
  platform: string;

/**
 * SDK version.
 */
  version: string;

/**
 * Type of data being processed.
 */
  dataType: string;
  
    /**
     * JSON payload containing the data.
     */
    body?: any
}

export function sdkProcessPlatformVersionDataTypePost(http: HttpClient, rootUrl: string, params: SdkProcessPlatformVersionDataTypePost$Params, context?: HttpContext): Observable<WearablesStrictHttpResponse<ProcessResponseModel>> {
  const rb = new RequestBuilder(rootUrl, sdkProcessPlatformVersionDataTypePost.PATH, 'post');
  if (params) {
    rb.path('platform', params.platform, {});
    rb.path('version', params.version, {});
    rb.path('dataType', params.dataType, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as WearablesStrictHttpResponse<ProcessResponseModel>;
    })
  );
}

sdkProcessPlatformVersionDataTypePost.PATH = '/SDK/Process/{platform}/{version}/{dataType}';
